import { useEffect, useRef } from 'react';
import { useAssignTag, useMailTags, useMessageTags } from '../mail/hooks';
import { useMailModel } from './use-mail-model';

export function useAutoSuggestTags(messageId: string | undefined, subject: string | null, bodyText: string | null) {
  const { suggest } = useMailModel();
  const { data: messageTags } = useMessageTags(messageId);
  const { data: allTags } = useMailTags();
  const { mutateAsync: assignTag } = useAssignTag();
  const didRun = useRef(false);

  useEffect(() => {
    if (!messageId || didRun.current) return;
    if (messageTags === undefined || allTags === undefined) return;
    if (messageTags.length > 0) return;

    didRun.current = true;

    const snippet = [subject, bodyText].filter(Boolean).join('\n').slice(0, 3000);
    const existingTagNames = allTags.map((t) => t.name);

    // suggest() triggers lazy model download internally — no isReady check needed
    suggest(snippet, existingTagNames).then(async (suggestions: string[]) => {
      console.debug('[AutoSuggest] suggestions:', suggestions);
      for (const name of suggestions) {
        await assignTag({ messageId, name, status: 'suggested' }).catch((err: unknown) => {
          console.error('[AutoSuggest] assignTag failed for', name, ':', err);
        });
      }
    }).catch((err) => {
      console.error('[AutoSuggest] suggestion failed:', err);
    });
  }, [messageId, messageTags, allTags, subject, bodyText, suggest, assignTag]);
}
